import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Box,
  Popover,
} from '@mui/material';


const EditorPopover = ({ open, onClose, children }) => {

  return (
    <Popover
      open={open}
      onClose={onClose?onClose:null}
      anchorReference="anchorPosition"
      anchorPosition={{ top: 110, left: 250 }}
      disableEnforceFocus={true}
      sx={{
        pointerEvents:"none",
        "& .MuiPaper-root" : {
          pointerEvents:"all",
        }
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      >
      <Box sx={{
        userSelect:"none",
        /* ⛔ 300 px pour ecrire deux explications de trois phrases, c'etait
           trop etroit. Nawal : « je n'avais pas l'espace dans l'admin pour le
           remplir ». Le panneau flotte au-dessus du lecteur, l'elargir ne
           coute rien a personne. */
        width:"420px",
        maxWidth:"calc(100vw - 260px)",
        maxHeight:"calc(100vh - 140px)",
        overflowY:"auto",
        padding:"10px",
        color:"black",
        fontSize:"12px"
      }}>
       {children}
      </Box>
    </Popover>
  )
};

export default EditorPopover;
